import React, { useEffect, useState } from "react";
import { Check } from "lucide-react";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";

const QueueSelect = ({ selectedQueueIds, onChange }) => {
  const [queues, setQueues] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/queue");
        setQueues(data);
      } catch (err) { toastError(err); }
    })();
  }, []);

  const toggle = (id) => {
    const next = selectedQueueIds.includes(id)
      ? selectedQueueIds.filter((q) => q !== id)
      : [...selectedQueueIds, id];
    onChange(next);
  };

  return (
    <div>
      <label className="block text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider mb-2">{i18n.t("queueSelect.inputLabel")}</label>
      <div className="flex flex-wrap gap-2 p-3 border border-slate-200 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 min-h-[48px]">
        {queues.map((queue) => (
          <button
            key={queue.id}
            type="button"
            onClick={() => toggle(queue.id)}
            className={`flex items-center gap-1.5 px-2.5 py-1 rounded-lg text-xs font-semibold transition-all border ${
              selectedQueueIds.includes(queue.id)
                ? "text-white border-transparent"
                : "text-slate-600 dark:text-slate-300 border-slate-200 dark:border-slate-600 hover:border-slate-300"
            }`}
            style={selectedQueueIds.includes(queue.id) ? { backgroundColor: queue.color, borderColor: queue.color } : {}}
          >
            {selectedQueueIds.includes(queue.id) && <Check className="w-3 h-3" />}
            {queue.name}
          </button>
        ))}
        {queues.length === 0 && <p className="text-xs text-slate-400">No hay colas disponibles</p>}
      </div>
    </div>
  );
};

export default QueueSelect;
